export default {
  showRegistrationModalOnQr: false,
  general: {
    showFavourites: false,
    showSoldNeighbourhoods: false,
    showLayoutSwitchToggle: true,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
